import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { ContentFragment } from 'client/site-modules/shared/components/content-fragment/content-fragment';
/* Constants */
import {
  PRIVATE_PARTY_SELL_CAR_CTA,
  CREATIVE_ID_ENTRY_PRIVATE_PARTY,
  PRIVATE_PARTY_SELL_CAR_WIDGET,
} from 'site-modules/shared/constants/private-party/private-party';
import { PRIVATE_PARTY_EVENTS } from 'site-modules/shared/constants/private-party/private-party-events';
/* Utils */
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { venomHistory } from 'client/utils/history/venom-history';
import { getCreateListingUrl } from 'site-modules/shared/utils/private-party/private-party';
/* Tracking */
import { EventToolbox } from 'client/utils/event-toolbox';
import { EngagementHandler } from 'client/engagement-handlers';
import { PrivatePartyEngagementHandler } from 'client/engagement-handlers/private-party-engagement-handler/private-party-engagement-handler';

import './private-party-sell-car-widget.scss';

EngagementHandler.register(PrivatePartyEngagementHandler);

export function PrivatePartySellCarWidget({ isMobile = false }) {
  const { imageSrc, imageSrcMobile, benefits, header } = PRIVATE_PARTY_SELL_CAR_WIDGET;

  const url = getCreateListingUrl();
  const image = isMobile ? imageSrcMobile : imageSrc;

  const handleClick = useCallback(() => {
    EventToolbox.fireCustomEvent(PRIVATE_PARTY_EVENTS.START_PP_LISTING, {
      value: PRIVATE_PARTY_SELL_CAR_CTA,
      creativeId: CREATIVE_ID_ENTRY_PRIVATE_PARTY,
    });

    venomHistory.push(url);
  }, [url]);

  return (
    <div
      data-tracking-parent={CREATIVE_ID_ENTRY_PRIVATE_PARTY}
      className="private-party-sell-car-widget-wrapper bg-white mb-0_5 px-1_5 px-md-2 py-2"
    >
      <ContentFragment classes="d-inline size-24 text-cool-gray-10 fw-bold pos-r">{header}</ContentFragment>

      <div className="d-flex flex-column flex-md-row mt-1_5">
        <img
          src={getStaticImageUrl(image)}
          className="mb-1_5 mb-md-0 me-md-2 mx-auto mx-md-0"
          width={isMobile ? 239 : 167}
          height={isMobile ? 159 : 135}
          alt=""
          loading="lazy"
        />
        <div>
          <ul className="list-unstyled mb-0 benefits-list">
            {benefits.map((benefit, index) => (
              <li key={`benefit_${index + 1}`} className="d-flex align-items-center pb-0_5 benefit-item">
                <i aria-hidden className="icon-checkmark me-0_75 text-blue-50" />
                <div>
                  <ContentFragment classes="d-inline size-16">{benefit}</ContentFragment>
                </div>
              </li>
            ))}
          </ul>

          <Button
            className="btn-blue-50 text-transform-none size-16 text-white py-1 px-2 mt-1 mt-md-1 mx-auto mx-md-0 d-block"
            onClick={handleClick}
          >
            {PRIVATE_PARTY_SELL_CAR_CTA}
          </Button>
        </div>
      </div>
    </div>
  );
}

PrivatePartySellCarWidget.propTypes = {
  isMobile: PropTypes.bool,
};
